import { doc, onSnapshot, setDoc } from 'shared/services/firebase';
import { ref } from 'vue';

export default function useSettings(db, user, subscriptionManager) {
  const settings = ref({});
  const loading = ref(false);

  const init = () => {
    loading.value = true;
    const unsubscribe = onSnapshot(doc(db, 'settings', user.value.uid), (querySnapshot) => {
      if (querySnapshot.exists()) {
        settings.value = querySnapshot.data();
      }
      loading.value = false;
    });
    subscriptionManager.addSubscriber(unsubscribe, { auth: true });
  };

  const save = async (data) => {
    const settingsRef = doc(db, 'settings', user.value.uid);
    return setDoc(settingsRef, data, { merge: true });
  };

  return { init, settings, save, loading };
}
